module.exports = __webpack_public_path__ + "img/M007-08_jrb-04_02.81da92c3.jpg";